/** @format */

import { BASE_URL, XAMPLIFIER_BASE_URL, INSIGHT_URL } from "../config";

export const API_ROUTES = {
  GET_CONFIG: `${BASE_URL}getConfig`,
  GET_LOCATION: `${BASE_URL}getLocation`,
  GET_PROVIDERS: `${BASE_URL}getProviders`,
  GET_SERVICE_TYPE: `${BASE_URL}getServiceType`,
  GET_PATIENT: `${BASE_URL}getPatients`,
  GET_PATIENT_DETAILS: `${BASE_URL}getPatientsAndLastAppointments`,

  GET_STATES: `${BASE_URL}getStates`,
  GET_INSURANCE: `${BASE_URL}getInsurance`,
  // GET_CLIENTBRAND: `${BASE_URL}getClientBrands`,
  GET_TOPINSURANCE: `${BASE_URL}insurance/topInsurancePackage`,
  GET_ASSIGN_CONFIG: `${BASE_URL}getAssignConfig`,
  GET_PATIENT_APPOINTMENTS: `${BASE_URL}getPatientAppointments`,

  POST_CREATE_PATIENT: `${BASE_URL}createPatients`,
  POST_CREATE_PATIENT_INSURANCE: `${BASE_URL}insurance/postInsurance`,
  POST_INSURANCE_CARD: `${BASE_URL}insuranceCardImage`,
  POST_JOINWAITLIST: `${BASE_URL}createWaitList`,
  POST_ANALYTICS: `${BASE_URL}updateUserSession`,
  POST_ACCESS_TOKEN: `${BASE_URL}client/accessToken`,
  POST_USER_SESSION_UPDATE: `${BASE_URL}storeUserSessionDetails`,

  GET_INSURANCE_PROVIDER_MAP: `${BASE_URL}getInsuranceProviderMap`,
  GET_PROVIDER_INSURANCE: `${BASE_URL}getProviderInsurance`,
  PUT_BOOKING_APPOINTMENT: `${BASE_URL}bookAppointment`,
  POST_BOOK_APPOINTMENT_FLOW: `${BASE_URL}bookAppointmentFlow`,
  GET_RESCHEDULE_LINK: `${BASE_URL}rescheduleLink`,
  GET_RELATIONSHIP: `${BASE_URL}insurance/getRelationshipToPatient`,

  //Admin
  GET_ADMIN_LOCATION: `${BASE_URL}providerLocationMap`,
  GET_ADMIN_SERVICETYPE: `${BASE_URL}getProviderAppointmentMap`,
  GET_ALL_PROVIDER: `${BASE_URL}getAllProviders`,
  GET_SINGLE_PROVIDER: `${BASE_URL}getProviderByProviderId`,
  GET_WAITLIST: `${BASE_URL}getWaitList`,
  GET_SERVICELOCATION_MAPPING: `${BASE_URL}getServiceLocationMapping`,
  GET_USER_DETAILS: `${XAMPLIFIER_BASE_URL}user`,
  GET_CLIENTBRAND: `${XAMPLIFIER_BASE_URL}clients`,
  GET_SWITCH_CLIENT: `${XAMPLIFIER_BASE_URL}switch/clients`,
  GET_INSURANCE_TYPE: `${BASE_URL}getInsuranceType`,
  GET_INSURANCE_CONTROL_DATA: `${BASE_URL}insurance/getInsuranceControlData`,
  GET_PROVIDER_INSURANCE_PLAN: `${BASE_URL}insurance/getProviderByInsurancePlan`,
  GET_REPORTS: `${BASE_URL}getAppointmentReport`,
  GET_ANALYTICS_REPORT: `${BASE_URL}report/getChartReport`,
  GET_CHANNEL: `${BASE_URL}report/getChannelFilters`,
  GET_APPOINTMENT_REPORTS: `${BASE_URL}report/getAppointmentReport`,
  GET_MAS_MAPPING: `${BASE_URL}getMasMapping`,
  GET_SCHEDULER_MAPPING: `${BASE_URL}getSchedulerName`,
  GET_PATIENTLIST: `${INSIGHT_URL}/api/getPatientList`,
  GET_META_BASE_ANALYTICS: `${BASE_URL}analytics/getMetabaseJWTToken`,
  GET_SCHEDULER_LIST: `${BASE_URL}getSchedulerList`,
  GET_PATIENT_FILTER: `${INSIGHT_URL}/api/get_filters`,
  GET_PATIENT_TAB_DETAILS: `${INSIGHT_URL}/api/getPatientDetails`,
  GET_APPOINTMENT_TAB_DETAILS: `${INSIGHT_URL}/api/getAppointmentDetails`,
  GET_FEEDBACK_TAB_DETAILS: `${INSIGHT_URL}/api/getFeedbackDetails`,

  UPDATE_PATIENT_STATUS: `${INSIGHT_URL}/api/update_appointment_status`,
  POST_UPDATA_LOCATION_MAPPING: `${BASE_URL}providerLocationMapAssign`,
  POST_UPDATA_SERVICE_MAPPING: `${BASE_URL}insertApptProviderMap`,
  POST_SERVICELOCATION_CONFIG: `${BASE_URL}createServiceLocationConfig`,
  POST_CREATE_LOCATION_PROVIDER_CONFIG: `${BASE_URL}createLocationProviderConfig`,
  POST_CREATE_PROVIDER_INSURANCE: `${BASE_URL}createInsuranceProviderConfig`,
  POST_INSURANCE_VALIDATION: `${BASE_URL}insuranceValidation`,
  POST_LOGIN: `${XAMPLIFIER_BASE_URL}login`,
  POST_ADMIN_LOGIN: `${BASE_URL}adminLogin`,
  POST_GENERATE_URL: `${BASE_URL}generateURL`,
  POST_ADD_NOTE: `${INSIGHT_URL}/api/addNote`,
  POST_ADD_SCHEDULER: `${BASE_URL}addSchedular`,
  POST_CREATE_LEAD_DATA: `${BASE_URL}createLeadData`,

  // Virtual Check-in → backend fills PDF templates and stores uploads on S3.
  POST_CHECKIN_SUBMIT: `${BASE_URL}submitCheckInForms`,
  POST_CHECKIN_TEMP_UPLOAD: `${BASE_URL}checkinTempUploadUrl`,
  GET_CHECKIN_APPOINTMENT_DETAILS: `${BASE_URL}getAppointmentDetails`,
  CHECKING_DRAFTS: `${BASE_URL}checkingDrafts`,

  PATCH_UPDATA_PROVIDERINFO: `${BASE_URL}updateProviderInfo`,
  PATCH_UPDATE_CONFIG: `${BASE_URL}updateConfig`,
  PATCH_UPDATE_SCHEDULER: `${BASE_URL}updateSchedular`,
  PATCH_SCHEDULER_STATUS: `${BASE_URL}updateSchedulerStatus`,
  POST_PATIENT_APPT_STATUS: `${BASE_URL}appointmentStatusUpdate`,
  PUT_UPDATE_NOTE: `${INSIGHT_URL}/api/editNote`,

  DELETE_SCHEDULER_ITEM: `${BASE_URL}deleteScheduler`,
};
